<script lang='ts'>
    export let id: string;
    export let functions: any;
    export let selected:boolean = false;

    import ColorSwatch from './color-swatch.svelte';
    import Button from '../components/button.svelte';
    import {appState, familiesS, lightnessParamsS, prefs} from '../stores.js';
    import { onDestroy } from 'svelte';
    import SmallIconButton from '../components/small-icon-button.svelte';

    // find the index of the correct family
    let index = functions.getFamilyIndex(id);

    const familyNameID = $familiesS[index].name.toLowerCase().replace(/\s/g, '_');

    $: cantMoveUp = index === 0;
    $: cantMoveDown = index === $familiesS.length - 1;

    function handleKeydown(event) {
        if (event.keyCode === 13 || event.keyCode === 32) {
            functions.manageAppState('family', id);
            functions.manageAppState('familySelectedIndex', index);

        }
    }

    let famDrag;
    $: isDragging = false;
    let isMouseDown = false;
    let movingIndex;
    let famHeight, famDomEl, bottomBound, topBound;
    let boxInfo;
    function handleClick(event) {
        // init
        isMouseDown = true;
        event.preventDefault();
        boxInfo = famDomEl.getBoundingClientRect();
        topBound = boxInfo.top;
        bottomBound = boxInfo.bottom;
        movingIndex = index;
        // console.log('boxInfo.top:' + boxInfo.top);
        // console.log('clicked');
        isDragging = false;
        famDrag = window.setTimeout(()=>{
            startFamDrag(event);
        }, 100);
        // document.onmouseup = handleMouseUp();
    }
    // need a mouseup func to cancel drag and ensure the fam gets selected
    function handleMouseUp() {
        if (isMouseDown) {
            if (!isDragging || movingIndex === index) {
                // console.log('no drag initiated')
                clearTimeout(famDrag);
                functions.manageAppState('family', id);
                functions.manageAppState('familySelectedIndex', index);
                // ...and just in case the browser went haywire
                document.onmousemove = null;
                // document.removeEventListener('onmousemove', watchFamDrag);
            } else {
                // console.log('drag ended')
                isDragging = false;
                // ...and just in case the browser went haywire
                document.onmousemove = null;
                // document.removeEventListener('onmousemove', watchFamDrag);
            }
        }
        isMouseDown = false;
    }

    function startFamDrag(event) {
        // console.log('is dragging')
        isDragging = true;
        document.onmousemove = watchFamDrag
        // document.addEventListener('onmousemove', watchFamDrag);
    }

    function watchFamDrag(event) {
        // console.log('mouse:' + event.clientY);
        if (event.clientY > bottomBound && movingIndex < ($familiesS.length -1)) {
            // move down
            functions.move(false, id);
            topBound = topBound + famHeight;
            bottomBound = bottomBound + famHeight;
            movingIndex++;
        } else if (event.clientY < topBound && movingIndex > 0) {
            // move up
            functions.move(true, id);
            movingIndex--;
            topBound = topBound - famHeight;
            bottomBound = bottomBound - famHeight;
        }
    }

    onDestroy(() => {
        console.log('Destroying ' + id);
        functions.updateAll();
    });

    function justClick() {
        functions.manageAppState('family', id);
        functions.manageAppState('familySelectedIndex', index);
    }

</script>
<svelte:window on:mouseup={handleMouseUp}/>
<div class="family-area" style="--swatch-cols: {$familiesS[index].swatchGroup.length}" class:not-selected="{!selected && $appState.familySelected}">

    <div class="swatch-group-area" class:selected="{selected}" class:dragging="{isDragging}" bind:clientHeight={famHeight} bind:this={famDomEl} on:mousedown={justClick} tabindex={index + 1} on:keydown={handleKeydown}>
        <div class="swatch-group">
            {#each $familiesS[index].swatchGroup as swatch, i}
                <ColorSwatch
                    famID={id}
                    swatchID={i}
                    a11y={$prefs.swatchA11y}
                    anchorIcon={swatch.anchorIcon}
                    textContrastData={swatch.textContrastData} />
            {/each}
        </div>
    
        <div class="move-button-group large-only">
            <div class="vert-align">
                {#if !cantMoveUp}
                    <SmallIconButton icon="carret up" handleClick={() => {functions.move(true, id);}} disabled={cantMoveUp} />
                {/if}
                
                {#if !cantMoveDown}
                    <SmallIconButton icon="carret down" handleClick={() => {functions.move(false, id);}} disabled={cantMoveDown} />
                {/if}

                <!-- <Button label="" handleClick={() => {functions.move(true, id);}} role="tertiary" disabled={cantMoveUp} icon={'carret up'} />
                <Button label="" handleClick={() => {functions.move(false, id);}} role="tertiary" disabled={cantMoveDown} icon={'carret down'} /> -->
            </div>
        </div>
    </div>

</div>


<style>
    .family-area {
        width: 100%;
        transition: 1s;
    }
    .swatch-group-area {
        display: grid;
        grid-template-columns: auto 56px;
        height: 100%;
        box-sizing: border-box;
        /* padding-left: 0.5rem; */
    }
    .swatch-group-area::after {
        content: '';
        z-index: 2;
        box-shadow: inset 0 0 0 1px color-mix(in srgb, var(--text), transparent 100%);;
        width: 100%;
        height: 100%;
        display: block;
        position: absolute;
        pointer-events: none;
        outline: none;
        transition: 0.5s;
    }
    .swatch-group-area.selected::after {
        content: '';
        box-shadow: inset 0 0 0 1px color-mix(in srgb, var(--text), transparent 70%);
    }
    .swatch-group-area:hover::after {
        box-shadow: inset 0 0 0 5px color-mix(in srgb, var(--text), transparent 90%);
    }
    .swatch-group-area:hover .move-button-group {
        visibility: visible;
    }
    .swatch-group-area.selected .move-button-group {
        visibility: visible;
    }
    .swatch-group-area.dragging {
        z-index: 1;
    }
    .swatch-group {
        width: 100%;
        height: 100%;
        display: grid;
        grid-template-columns: repeat(var(--swatch-cols), 1fr);
        background-color: var(--background);
        position: relative;
    }
    .swatch-group-area:focus-visible::after {
        box-shadow: inset 0 0 0 4px var(--text);
        z-index: 2;
    }
    .move-button-group {
        align-items: center;
        visibility: hidden;
    }
    .move-button-group > * {
        vertical-align: middle;
    }
    .vert-align {
        position: relative;
        top: 50%;
        transform: translateY(-50%);
        text-align: center;
        padding: 0.5rem 0;
    }
    .large-only {
        display: initial;
    }

    @media (max-width: 960px) {
        .selected {
            min-height: 120px;
        }
        .not-selected {
            min-height: 2px;
            /* max-height: 4px; */
            overflow: hidden;
        }
        .family-area {
            grid-template-columns: 1fr;
            direction: ltr;
            grid-template-rows: auto 0 0;
        }
        .swatch-group-area {
            grid-template-columns: auto 0;
            padding-left: 0;
        }
        .swatch-group {
            top:0;
            grid-template-rows: auto;
            direction: ltr;
            grid-template-columns: repeat(var(--swatch-cols), auto);
            /* min-height: 96px; */
        }

        .large-only {
            display: none;
        }
	}
</style>